import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

export default function SearchBar({
  options,
  customClasses,
  isInternalPage = true,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);

  const path = location.pathname;
  const getDefaultPropertyType = () => {
    if (path.includes("commercialRealEstate")) return "commercial";
    if (path.includes("residentialRealEstate")) return "residential";
    if (path.includes("upcoming-properties")) return "offPlan";
    if (path.includes("holidayHomes")) return "HolidayHome";
    if (path.includes("holidayHomes")) return "HolidayHome";
    return sessionStorage.getItem("propertyType") || "";
  };

  const [transactionType, setTransactionType] = useState(
    sessionStorage.getItem("transactionType") || "Buy"
  );
  const [propertyType, setPropertyType] = useState(getDefaultPropertyType());
  const [puType, setPropertyT] = useState(
    sessionStorage.getItem("puType") || ""
  );
  const [pStatus, setPstatus] = useState("");
  const [city, setCity] = useState(sessionStorage.getItem("city") || "");
  const [minPrice, setMinPrice] = useState(
    sessionStorage.getItem("minPrice") || ""
  );
  const [maxPrice, setMaxPrice] = useState(
    sessionStorage.getItem("maxPrice") || ""
  );
  const [bedroom, setBedroom] = useState(
    sessionStorage.getItem("bedroom") || ""
  );
  const [bathroom, setBathroom] = useState(
    sessionStorage.getItem("bathroom") || ""
  );
  const [toggle, setToggle] = useState(false);

  const handleClick = () => setToggle(!toggle);
  const handleSelect = (value) => {
    setCity(value);

    setToggle(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();

    const result = {
      type: transactionType,
      city: city || "Dubai",
      PType: puType,
      ...(propertyType && { propertyType }), // ✅ always include when available
      ...(isInternalPage && {
        minPrice: minPrice || "Any",
        maxPrice: maxPrice || "Any",
        bedroom: bedroom || "Any",
        bathroom: bathroom || "Any",
      }),
    };

    let query = `type=${result.type}&PType=${result.PType}&city=${result.city}`;
    if (result.propertyType) {
      query += `&propertyType=${result.propertyType}`;
    }
    if (isInternalPage) {
      query += `&minPrice=${result.minPrice}&maxPrice=${result.maxPrice}&bedroom=${result.bedroom}&bathroom=${result.bathroom}`;
    }
    console.log(`${process.env.REACT_APP_API_URL}/api/properties?${query}`);
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/properties?${query}`)
      .then((res) => {
        navigate(`/searchResult?${query}`, { state: { data: res.data } });
      })
      .catch((err) => {
        console.log(err.message);
      });

    sessionStorage.setItem("transactionType", transactionType);
    sessionStorage.setItem("city", city);
    sessionStorage.setItem("propertyType", propertyType);
    sessionStorage.setItem("puType", puType);
    sessionStorage.setItem("minPrice", minPrice);
    sessionStorage.setItem("maxPrice", maxPrice);
    sessionStorage.setItem("bedroom", bedroom);
    sessionStorage.setItem("bathroom", bathroom);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setToggle(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (location.pathname === "/commercialRealEstate") {
      setPropertyType("commercial");
    } else if (location.pathname === "/residentialRealEstate") {
      setPropertyType("residential");
    } else if (location.pathname === "/upcoming-properties") {
      setPropertyType("off plan");
    }
  }, [location.pathname]);

  return (
    <div
      className={`z-20 w-full px-4 md:px-10 flex justify-center items-center ${
        customClasses || "mt-10"
      }`}
    >
      <div className="w-full max-w-4xl p-6 shadow-xl bg-white/30 backdrop-blur-md rounded-xl md:p-8">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-4">
          <select
            className="w-full px-3 py-2 text-sm text-gray-700 border border-gray-300 rounded-md bg-white/90"
            value={transactionType}
            onChange={(e) => setTransactionType(e.target.value)}
          >
            <option value="Buy">Buy</option>
            <option value="Rent">Rent</option>
          </select>

          <select
            className="w-full px-3 py-2 text-sm text-gray-700 border border-gray-300 rounded-md bg-white/90"
            value={propertyType}
            onChange={(e) => setPropertyType(e.target.value)}
          >
            <option value="">Select Property Use Type</option>
            <option value="commercial">Commercial</option>
            <option value="residential">Residential</option>
            <option value="offPlan">Off Plan</option>
          </select>

          <select
            className="w-full px-3 py-2 text-sm text-gray-700 border border-gray-300 rounded-md bg-white/90"
            value={puType}
            onChange={(e) => setPropertyT(e.target.value)}
          >
            <option value="">Select Type</option>
            <option value="apartment">Apartment</option>
            <option value="villa">Villa</option>
            <option value="townhouse">Townhouse</option>
            <option value="pent_house">Pent House</option>
            <option value="office_space">Office space</option>
          </select>

          <div className="relative w-full" ref={dropdownRef}>
            <button
              onClick={handleClick}
              className="w-full px-3 py-2 text-sm text-left text-gray-700 border border-gray-300 rounded-md bg-white/90"
            >
              {city || "Select Location"}
            </button>
            {toggle && (
              <div className="absolute z-10 w-full mt-2 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-md top-full max-h-60">
                {options.map((option) => (
                  <div
                    key={option}
                    onClick={() => handleSelect(option)}
                    className="px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-blue-600 hover:text-white"
                  >
                    {option}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="mt-6 text-center">
          <button
            onClick={handleSearch}
            className="inline-flex items-center gap-2 bg-[#173D73] hover:bg-[#DE241A] text-white text-sm font-semibold px-8 py-3 rounded-md transition-all"
          >
            <FontAwesomeIcon icon={faSearch} />
            Search Properties
          </button>
        </div>
      </div>
    </div>
  );
}



